<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="d-flex">
                    <div class="align-self-center">
                        <h4 class="card-title m-t-10">Membresias Actuales</h4></div>
                    <div class="ml-auto">
                        <div class="input-group">
                            <button (click)="openModal(content1)" class="btn btn-sm btn-warning btn-create">
                                Nueva membresia
                            </button>
                            <button (click)="openModal(content3)" class="btn btn-sm btn-warning btn-create">
                                Membresia Usuario
                            </button>
                        </div>
                    </div>
                </div>
                <br>
                <div class="table-responsive m-t-40">
                    <table id="tabla-condominios" class="table table-bordered table-striped">
                        <thead>
                            <tr>

                                <th>Titulo</th>
                                <th>Descripcion</th>
                                <th>Precio</th>
                                <th>Tiempo</th>
                                <th>Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of condominio_list">
                                <td>
                                    <img src="{{ c.imagen }}" alt="user" height="50" width="50" class="img-circle"> {{ c.titulo }}
                                </td>
                                <td>{{ c.descripcion }}</td>
                                <td>{{ c.precio }}</td>
                                <td>{{ c.tiempo }}</td>
                                <td> 
                                    <div class="btn btn-group">
                                        <a type="button" [routerLink]="['/admin/condominios', c.id ]" routerLinkActive="router-link-active"  class="btn btn-secondary"> <i class="fa fa-edit"> </i></a>
                                    </div>
                                </td>
                            </tr>
                           
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
    </div>
</div>



<ng-template #content1 let-modal>
    <div class="modal-header">
        Generar Membresia
    </div>
    <div class="modal-body">
        <form [formGroup]="Form">
            <div class="form-group">
                <label>Titulo</label>
                <div class="input-group">
                    <input formControlName="titulo" type="text" class="form-control">
                </div>
                <label>Descripcion</label>
                <div class="input-group">
                    <input formControlName="descripcion" type="text" class="form-control">
                </div>
                <label>Precio</label>
                <div class="input-group">
                    <input formControlName="precio" type="number" class="form-control">
                </div>
                <label>Cantidad viviendas</label>
                <div class="input-group">
                    <input formControlName="cantidad_viviendas" type="number" class="form-control">
                </div>
                <label>Tiempo</label>
                <div class="input-group">
                    <input formControlName="tiempo" type="number" class="form-control">
                </div>
                <label>Imagen noticia</label>
                <div class="form-group text-center">
                    <div class="fileupload btn btn-danger btn-rounded waves-effect waves-light"><span><i
                                class="fa fa-camera"></i> Seleccionar Imagen</span>
                        <input type="file" accept="image/*" (change)="seleccionImage($event)" class="upload">
                    </div>
                </div>
                </div>
        </form>
    </div>
    <div class="modal-footer">
        <button (click)="NuevaMembresia()">Generar Membresia</button>
    </div>
</ng-template>
<ng-template #content3 let-modal>
    <div class="modal-header">
        Asignación Membresia
    </div>
    <div class="modal-body">
        <form [formGroup]="Form3">
            <div class="form-group">
                <label>fecha fin</label>
                <div class="input-group">
                    <input formControlName="fecha_fin" type="date" class="form-control">
                </div>
                <label>Membresias</label>
                        <select class="form-control" formControlName="id_usuario">
                            <option *ngFor="let item of condominio_list" value="{{item.id}}">{{ item.titulo }} - {{ item.descripcion}}</option>
                        </select>
                <label>Usuarios Admin</label>
                        <select class="form-control" formControlName="id_condominio_membresia">
                            <option *ngFor="let item of usuarios_list" value="{{item.id}}"> {{ item.email}}</option>
                        </select>
                </div>
        </form>
    </div>
    <div class="modal-footer">
        <button (click)="AsignarMembresia()">Generar Membresia</button>
    </div>
</ng-template>
<!--
<div id="modal-eliminar" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <form class="modal-dialog" [formGroup]="formDataDelete">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Eliminar Condominio</h4>
                <button type="button" (click)="condominio_id = 0; condominio_name = '';" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="alert alert-warning" role="alert">
                <a href="#" class="alert-link">¡Cosas inesperadas sucederán si no lees esto!</a>
            </div>
            <div class="modal-body">
                <strong>Esta acción no se puede deshacer.</strong>
                <br>
                <p>Esto eliminará permanentemente el condominio y todo lo relacionado
                    con el dejará de ser accesible.</p>
                <p>Escriba "<strong *ngIf="condominio_name">{{condominio_name}}</strong>" para confirmar.</p>
                <div class="form-group">
                    <input type="text" class="form-control" id="recipient-name" formControlName="nombreConfirm"
                        name="nombreConfirm">
                    <div *ngIf="formDataDelete.controls.nombreConfirm.invalid && (formDataDelete.controls.nombreConfirm.dirty || formDataDelete.controls.nombreConfirm.touched)">
                        <div class="alert alert-danger" role="alert" *ngIf="formDataDelete.controls.nombreConfirm.errors.required">
                            El título es requerido
                        </div>
                    </div>
                    <div *ngIf="!formDataDelete.controls.nombreConfirm.invalid && formDataDelete.controls.nombreConfirm.value != condominio_name">
                        <div class="alert alert-danger" role="alert">
                            Los nombres no coinciden
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="modal-footer">
                <button type="button" (click)="condominio_id = 0; condominio_name = '';" class="btn btn-secondary text-uppercase btn-rounded"
                    data-dismiss="modal">Cerrar</button>
                <button type="submit" (click)="delete()" [disabled]="formDataDelete.controls.nombreConfirm.value != condominio_name"
                    class="btn btn-danger text-uppercase btn-rounded">Eliminar</button>
            </div>
        </div>
    </form>
</div>
-->